import { render, staticRenderFns } from "./DetailsBrandModal.vue?vue&type=template&id=676d93b0&scoped=true"
import script from "./DetailsBrandModal.vue?vue&type=script&lang=ts"
export * from "./DetailsBrandModal.vue?vue&type=script&lang=ts"
import style0 from "./DetailsBrandModal.vue?vue&type=style&index=0&id=676d93b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676d93b0",
  null
  
)

export default component.exports